import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react";

import authStore from "../stores/authStore";
import CostModal from "./modal/CostModal";

const Global = () => {
  const { dialog, fetchMemberInfo } = useContext(authStore);

  useEffect(() => {
    fetchMemberInfo();
  }, []);

  return (
    <div className="article-global">
      {dialog.buyVip && <CostModal />}
    </div>
  );
};

export default observer(Global);
